module.exports = __webpack_public_path__ + "Roboto-Bold.c0f1e4a4fdfb8048c72e.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/roboto/Roboto-Bold.woff2
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Bold.woff2
// module chunks = styles